import { render } from "./MainLogo.vue?vue&type=template&id=6ef90332"
import script from "./MainLogo.vue?vue&type=script&lang=js"
export * from "./MainLogo.vue?vue&type=script&lang=js"

import "./MainLogo.vue?vue&type=style&index=0&id=6ef90332&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__